import Mock from 'mockjs';
const baseUrl = '/api';
const escapeRegExp = (str) => String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const toUrlRegExp = (url) => new RegExp(`^${escapeRegExp(url)}(\\?.*)?$`);
const jsonModules = require.context('./modules/', true, /\.json$/);
const jsonPathReg = /.(.*)\.json$/;
jsonModules.keys().forEach((modulePath) => {
  const value = jsonModules(modulePath);
  const template = value?.default ?? value;
  const path = modulePath.match(jsonPathReg)[1];
  const url = baseUrl + path;
  const urlReg = toUrlRegExp(url);
  Mock.mock(urlReg, 'post', Mock.mock(template));
  Mock.mock(urlReg, 'get', Mock.mock(template));
});

// JS mocks allow request-aware logic (pagination, filtering, etc.).
// Files prefixed with "_" are treated as helpers and ignored.
const jsModules = require.context('./modules/', true, /\.js$/);
const jsPathReg = /.(.*)\.js$/;
jsModules.keys().forEach((modulePath) => {
  if (modulePath.includes('/_')) return;

  const value = jsModules(modulePath);
  const handler = value?.default ?? value;
  const path = modulePath.match(jsPathReg)[1];
  const url = baseUrl + path;
  const urlReg = toUrlRegExp(url);

  if (typeof handler === 'function') {
    Mock.mock(urlReg, 'post', (options) => Mock.mock(handler(options)));
    Mock.mock(urlReg, 'get', (options) => Mock.mock(handler(options)));
  } else {
    Mock.mock(urlReg, 'post', Mock.mock(handler));
    Mock.mock(urlReg, 'get', Mock.mock(handler));
  }
});
// Mock.mock('/api/sms/getCountryList', 'get', Mock.mock(req => {
//   return {
//     data: {
//       a: 1
//     }
//   }
// }))
